import { createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from 'utils/axios';

export const getTestimonials = createAsyncThunk('testimonial/getTestimonials', async ({ type, page }, thunkAPI) => {
  try {
    const response = await axiosInstance.get(`/testimonies?type=${type}&page=${page}&limit=10`);

    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue('failed to get testimonial!');
  }
});

export const getTestimonialsById = createAsyncThunk('testimonial/getTestimonialsById', async (id, thunkAPI) => {
  try {
    const response = await axiosInstance.get(`/testimonies/${id}`);

    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue('failed to get testimonial!');
  }
});

export const createTestimonial = createAsyncThunk('testimonial/createTestimonial', async (payload, thunkAPI) => {
  try {
    const response = await axiosInstance.post(`/testimonies`, { ...payload });

    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue('failed to get testimonial!');
  }
});
export const updateTestimonial = createAsyncThunk('testimonial/updateTestimonial', async (payload, thunkAPI) => {
  const { id, data } = payload;

  try {
    const response = await axiosInstance.put(`/testimonies/${id}`, { ...data });

    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue('failed to update testimonial!');
  }
});

export const uploadTestimonialImage = createAsyncThunk(
  'testimonial/uploadTestimonialImage',
  async (payload, thunkAPI) => {
    try {
      const response = await axiosInstance.post(`/testimonies/upload`, payload, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      const imageUrl = response?.data.file;
      return imageUrl;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data?.data?.message || error.message);
    }
  },
);

export const deleteTestimonial = createAsyncThunk('testimonial/deleteTestimonial', async (id, thunkAPI) => {
  try {
    await axiosInstance.delete(`/testimonies/${id}`);
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data?.data?.message || error.message);
  }
});
